// extracted by css-extract-rspack-plugin
export default {"cls1":"CloseButton-cls1_6Ef","cls2":"CloseButton-cls2_bK1 CloseButton-cls1_6Ef"};